<template>
  <div class="card mb-25 border-0 rounded-0 bg-white edit-course-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <form @submit.prevent="createLivNote" v-if="user && user.role_id == 4">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Agence :
              </label>
              <v-select
                class="custom-select-height"
                :options="drivers"
                v-model="agencyLiv"
                label="name"
                placeholder="Choisir l'agence"
              >
                <!-- Corrected option template -->
                <template #option="{ name, nb_colis }">
                  <span>{{ name }} - {{ nb_colis }} Colis</span>
                </template>
              </v-select>
            </div>
          </div>

          <hr />

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <button class="btn btn-primary" type="submit">Ajouter</button>
            </div>
          </div>
        </div>
      </form>

      <form @submit.prevent="createSentNote" v-if="user && user.role_id == 3">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Agence :
              </label>
              <v-select
                class="custom-select-height"
                :options="agenciesList"
                v-model="agency"
                label="name"
                @update:modelValue="handleAgencySelection"
                placeholder="Select a zone"
              >
                <!-- Corrected option template -->
                <template #option="{ name, nb_colis }">
                  <span>{{ name }} - {{ nb_colis }} Colis</span>
                </template>
              </v-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Livreur :
              </label>
              <v-select
                class="custom-select-height"
                :options="drivers"
                v-model="driver"
                label="name"
              >
              </v-select>
            </div>
          </div>
          <hr />

          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <button class="btn btn-primary" type="submit">Ajouter</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import { onMounted, ref } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const agenciesListLiv = ref([]);
    const drivers = ref([]);
    const agencyLiv = ref<any | null>(null);
    const driver = ref<any | null>(null);
    const isLoader = ref(false);

    const agenciesList = ref([]);
    const agency = ref<any | null>(null);

    async function getAgencyLivs() {
      driver.value = null;
      const res = await api.get(`/api/auth/AgencyLiv?id_liv=${user?.id}`);
      drivers.value = res.data;
    }

    async function createLivNote() {
      if (!agencyLiv.value) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
        return;
      }

      const data = new FormData();
      data.append("liv_id", user?.id);
      data.append("liv_name", user?.name);
      data.append("agency_id", agencyLiv.value.id);
      data.append("agency_name", agencyLiv.value.name);
      data.append("zone_id", agencyLiv.value.id_zone);
      data.append("zone_name", agencyLiv.value.zone_name);
      // data.append('city_id', driver.value.city_id)
      // data.append('city_name', driver.value.ville)
      isLoader.value = true;

      try {
        const res = await api.post(`/api/auth/new_bon_distr`, data);

        if (res.data.message === "success") {
          const routeData = router.resolve({
            name: "AddColisDistrPage",
            params: { refNote: res.data.BDSTR.note_ref, id: res.data.BDSTR.id },
          });
          window.open(routeData.href, "_blank");
        } else {
          showToast(
            "Erreur lors de la création du bon de distribution",
            "error"
          );
        }
      } catch (error) {
        showToast("Erreur lors de la création du bon de distribution", "error");
      } finally {
        isLoader.value = false;
      }
    }

    onMounted(async () => {
      getAgencyLivs();

      try {
        const response = await api.get(`/api/auth/AgencyDistrList`);
        if (response && response.data) {
          console.log(response.data);
          agenciesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    async function getAgencies(id_agency: number) {
      driver.value = null;
      const res = await api.get(`/api/auth/LivsZone/${id_agency}`);
      drivers.value = res.data;
    }

    const handleAgencySelection = (agency: any) => {
      if (agency?.id) {
        getAgencies(agency.id);
      }
    };

    async function createSentNote() {
      if (!agency.value || !driver.value) {
        showToast(
          "Champs obligatoire, Merci de remplir tous les champs",
          "error"
        );
        return;
      }

      const data = new FormData();
      data.append("liv_id", driver.value.id);
      data.append("liv_name", driver.value.name);
      data.append("agency_id", agency.value.id);
      data.append("agency_name", agency.value.name);
      data.append("zone_id", agency.value.id_zone);
      data.append("zone_name", agency.value.zone_name);
      data.append("city_id", driver.value.city_id);
      data.append("city_name", driver.value.ville);
      isLoader.value = true;

      try {
        const res = await api.post(`/api/auth/new_bon_distr`, data);

        if (res.data.message === "success") {
          const routeData = router.resolve({
            name: "AddColisDistrPage",
            params: { refNote: res.data.BDSTR.note_ref, id: res.data.BDSTR.id },
          });
          window.open(routeData.href, "_blank");
        } else {
          showToast(
            "Erreur lors de la création du bon de distribution",
            "error"
          );
        }
      } catch (error) {
        showToast("Erreur lors de la création du bon de distribution", "error");
      } finally {
        isLoader.value = false;
      }
    }

    return {
      agenciesListLiv,
      drivers,
      isLoader,
      agencyLiv,
      driver,
      user,
      auth,
      getAgencyLivs,
      createLivNote,
      agenciesList,
      agency,
      createSentNote,
      handleAgencySelection,
    };
  },
});
</script>
